export default __webpack_public_path__ + "static/media/grad.51bd12ab.jpeg";